import React from 'react';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-white pb-12" data-id="element-36">
      {/* Top Bar */}
      <div className="w-full bg-red-600 text-white text-center py-3 px-4" data-id="element-37">
        <p className="font-bold text-sm md:text-base" data-id="element-38">
          ⏳ PRECIO DE LANZAMIENTO POR TIEMPO LIMITADO
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-8 md:pt-12 text-center" data-id="element-39">
        <p className="text-sm md:text-base text-gray-500 font-medium mb-4 uppercase tracking-wider" data-id="element-40">
          📌 Formación para padres de futbolistas
        </p>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-6 uppercase tracking-tight" data-id="element-41">
          Ayudá a tu hijo futbolista a recuperar confianza, manejar la presión y
          no abandonar su sueño.
        </h1>

        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-42">
          Para que no pierda confianza, gestione la presión y no abandone antes
          de desarrollar su potencial.
        </p>

        <div className="mb-8" data-id="element-43">
          <img src="https://cdn.magicpatterns.com/uploads/jxgEKvXjgSs49n8pfpjYvG/MOCKUP_FUTBOL.png" alt="Megapack Mentalidad Futbol" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-44" />
        </div>

        {/* Social Proof Badge */}
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-45">
          <p className="text-sm md:text-base font-bold text-gray-700" data-id="element-46">
            ⚽ +1.000 padres ya eligieron acompañar a sus hijos{' '}
            <span className="text-green-600" data-id="element-47">✓</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-4 mb-8 text-base md:text-lg text-gray-600" data-id="element-48">
          <p data-id="element-49">
            Programa de formación para padres basado en principios de psicología
            deportiva juvenil y acompañamiento competitivo adolescente.
          </p>
          <p data-id="element-50">
            Sistema estructurado para intervenir correctamente antes, durante y
            después de cada competencia.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-51">
          {['Acceso inmediato', 'Descarga digital', 'Pago único', 'Aplicación práctica inmediata'].map((item, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-green-50 text-green-800 border border-green-200 px-3 py-1.5 rounded-full text-sm font-medium" data-id="element-52">
              <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-53" />
              {item}
            </span>)}
        </div>

        <a href="#precio" className="inline-flex flex-col items-center justify-center gap-1 bg-green-600 hover:bg-green-700 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-lg shadow-lg transform transition hover:scale-105 hover:shadow-xl w-full md:w-auto" data-id="element-54">
          <span data-id="element-55">👉 QUIERO ACCEDER AL PROGRAMA</span>
          <span className="text-xs md:text-sm font-normal opacity-90" data-id="element-56">
            🔥 Precio de lanzamiento · 65% de descuento
          </span>
        </a>
      </div>
    </section>;
}